import React from 'react';
import { SiteContent } from 'components/common/styles';
import ContentLayout from 'components/ContentLayout';
import PatternCode from 'components/Admin/PatternCode';
// eslint-disable-next-line
export default function PatternCodeManager() {
  return (
    <ContentLayout>
      <SiteContent>
        <PatternCode />
      </SiteContent>
    </ContentLayout>
  );
}
